import strings from "components/release/useful-links/UsefulLinks.strings.json";
import { generateLinksBase } from "components/release/useful-links/helpers/generateLinksBase";
import type { SemVer } from "util/version";

// Generate list of links of a build for the given versions.
export const generateBuildLinks = (
  versions: SemVer[],
  appBuildUrls: Record<string, string | undefined>,
): JSX.Element[] =>
  generateLinksBase(versions, strings.DownloadBuild, undefined, appBuildUrls);
